module.exports = __webpack_public_path__ + "assets/img/mulazim.178f5848.png";